var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
var appKey = "YOUR_KINVEY_APP_KEY";
var appSecret = "YOUR_KINVEY_APP_SECRET";
var kinveyBaseUrl = "https://baas.kinvey.com/";
var getAllUrl = kinveyBaseUrl + 'appdata' + "/" + appKey + '/flats';
//POST /user/:appKey/ HTTP/1.1
var demoUsers = [
    {
        _id: 'demo-admin',
        username: 'demo',
        profilePic: 'https://boygeniusreport.files.wordpress.com/2016/05/scared-surprised-cat-face.jpg?quality=98&strip=all&w=782',
        isAdmin: 'Yes',
        _kmd: { authtoken: 'demo-token' }
    }
];
var demoCats = [
    {
        _id: 'demo-mila',
        name: 'Mila',
        breed: 'Street',
        age: 2,
        contactNumber: 359888111222,
        information: 'Calm indoor cat that is ready for a local adoption demo. This record is hardcoded for offline review.',
        imgUrl: 'https://cdn.pixabay.com/photo/2016/08/10/14/39/cat-1583459__340.png',
        imgUrl2: 'https://cdn.pixabay.com/photo/2017/11/09/21/41/cat-2934720__340.jpg',
        imgUrl3: 'https://cdn.pixabay.com/photo/2015/04/23/21/59/tree-736877__340.jpg',
        imgUrl4: 'https://cdn.pixabay.com/photo/2014/11/30/14/11/cat-551554__340.jpg',
        vaccinated: true,
        castrated: true,
        city: 'Sofia',
        _acl: { creator: 'demo-admin' }
    },
    {
        _id: 'demo-leo',
        name: 'Leo',
        breed: 'Tabby',
        age: 4,
        contactNumber: 359888333444,
        information: 'Playful cat listing used as local mock data when the historical Kinvey backend is unavailable.',
        imgUrl: 'https://cdn.pixabay.com/photo/2017/02/20/18/03/cat-2083492__340.jpg',
        imgUrl2: 'https://cdn.pixabay.com/photo/2018/01/28/12/37/cat-3113513__340.jpg',
        imgUrl3: 'https://cdn.pixabay.com/photo/2017/11/09/21/41/cat-2934720__340.jpg',
        imgUrl4: 'https://cdn.pixabay.com/photo/2016/08/10/14/39/cat-1583459__340.png',
        vaccinated: false,
        castrated: true,
        city: 'Plovdiv',
        _acl: { creator: 'demo-admin' }
    }
];
var demoMessages = [
    {
        _id: 'demo-message-1',
        message: 'Is Mila still available for adoption?',
        receiver: 'demo-admin',
        sender: 'demo-visitor',
        open: 'false',
        senderName: 'Portfolio Visitor',
        madeDate: '2026-05-14, 12:00',
        catName: 'Mila'
    }
];
var KinveyRemoteServiceService = /** @class */ (function () {
    function KinveyRemoteServiceService(http) {
        this.http = http;
    }
    //MAKE AUTH
    KinveyRemoteServiceService.prototype.makeAuth = function (type) {
        return type === 'basic'
            ? 'Basic ' + btoa(appKey + ':' + appSecret)
            : 'Kinvey ' + localStorage.getItem('authtoken');
    };
    //IS AUTH
    KinveyRemoteServiceService.prototype.isAuth = function () {
        return localStorage.getItem('authtoken') !== null;
    };
    //SAVE SESSION
    KinveyRemoteServiceService.prototype.saveSession = function (userData) {
        localStorage.setItem('authtoken', userData._kmd.authtoken);
        localStorage.setItem('username', userData.username);
        localStorage.setItem('userId', userData._id);
        localStorage.setItem('picUrl', userData.profilePic);
        localStorage.setItem('isAdmin', userData.isAdmin);
    };
    //POST
    KinveyRemoteServiceService.prototype.post = function (url, data, auth) {
        return this.http.post(url, data, { headers: { 'authorization': this.makeAuth(auth) } });
    };
    //PUT
    KinveyRemoteServiceService.prototype.put = function (url, data, auth) {
        return this.http.put(url, data, { headers: { 'authorization': this.makeAuth(auth) } });
    };
    //GET
    KinveyRemoteServiceService.prototype.get = function (url, auth) {
        return this.http.get(url, { headers: { 'authorization': this.makeAuth(auth) } });
    };
    //DELETE
    KinveyRemoteServiceService.prototype.delete = function (url, id, auth) {
        return this.http.delete(url, { headers: { 'authorization': this.makeAuth(auth) } });
    };
    //REGISTER
    KinveyRemoteServiceService.prototype.register = function (username, password, profilePic) {
        var userData = {
            _id: "demo-user-" + Date.now(),
            username: username,
            profilePic: profilePic || demoUsers[0].profilePic,
            isAdmin: 'No',
            _kmd: { authtoken: 'demo-token' }
        };
        demoUsers.push(userData);
        return of(userData);
    };
    //LOGIN
    KinveyRemoteServiceService.prototype.login = function (username, password) {
        return of(Object.assign({}, demoUsers[0], { username: username || demoUsers[0].username }));
    };
    //LOGOUT
    KinveyRemoteServiceService.prototype.logout = function () {
        localStorage.clear();
        return of({ ok: true });
    };
    //UPDATE USER
    KinveyRemoteServiceService.prototype.updateUser = function (username, password, id, profilePic) {
        var userData = Object.assign({}, demoUsers[0], { _id: id, username: username, profilePic: profilePic });
        return of(userData);
    };
    //CREATE CAT
    KinveyRemoteServiceService.prototype.CreateCat = function (name, breed, age, contactNumber, information, imgUrl, imgUrl2, imgUrl3, imgUrl4, vaccinated, castrated, city) {
        var obj = { _id: "demo-cat-" + Date.now(), name: name, breed: breed, age: age, contactNumber: contactNumber, information: information, imgUrl: imgUrl, imgUrl2: imgUrl2, imgUrl3: imgUrl3, imgUrl4: imgUrl4, vaccinated: vaccinated, castrated: castrated, city: city, _acl: { creator: localStorage.getItem('userId') || 'demo-admin' } };
        demoCats = [obj].concat(demoCats);
        return of(obj);
    };
    //CREATE MESSAGE
    KinveyRemoteServiceService.prototype.CreateMessage = function (message, receiver, sender, open, senderName, madeDate, catName) {
        var obj = { _id: "demo-message-" + Date.now(), message: message, receiver: receiver, sender: sender, open: open, senderName: senderName, madeDate: madeDate, catName: catName };
        demoMessages = [obj].concat(demoMessages);
        return of(obj);
    };
    //UPDATE MESSAGE
    KinveyRemoteServiceService.prototype.UpdateMessage = function (catName, senderName, open, sender, receiver, message, madeDate, id) {
        var obj = { catName: catName, senderName: senderName, open: open, sender: sender, receiver: receiver, message: message, madeDate: madeDate };
        demoMessages = demoMessages.map(function (messageData) { return messageData._id === id ? Object.assign({ _id: id }, obj) : messageData; });
        return of(Object.assign({ _id: id }, obj));
    };
    //DELETE MESSAGE
    KinveyRemoteServiceService.prototype.DeleteMessage = function (id) {
        demoMessages = demoMessages.filter(function (messageData) { return messageData._id !== id; });
        return of({ _id: id });
    };
    //GET ALL CATS
    KinveyRemoteServiceService.prototype.GetAllCats = function () {
        return of(demoCats);
    };
    //GET ALL USERS
    KinveyRemoteServiceService.prototype.GetAllUsers = function () {
        return of(demoUsers);
    };
    //DELETE USER
    KinveyRemoteServiceService.prototype.DeleteUser = function (id) {
        return of({ _id: id });
    };
    //GET CAT BY ID
    KinveyRemoteServiceService.prototype.GetCatById = function (id) {
        return of(demoCats.find(function (cat) { return cat._id === id; }) || demoCats[0]);
    };
    //UPDATE CAT BY ID
    KinveyRemoteServiceService.prototype.UpdateCat = function (name, breed, age, contactNumber, information, imgUrl, id) {
        var obj = { name: name, breed: breed, age: age, contactNumber: contactNumber, information: information, imgUrl: imgUrl };
        demoCats = demoCats.map(function (cat) { return cat._id === id ? Object.assign({}, cat, obj) : cat; });
        return of(Object.assign({ _id: id }, obj));
    };
    //DELETE CAT 
    KinveyRemoteServiceService.prototype.deleteCat = function (id) {
        demoCats = demoCats.filter(function (cat) { return cat._id !== id; });
        return of({ _id: id });
    };
    //GET MESSAGES
    KinveyRemoteServiceService.prototype.GetAllMessages = function () {
        return of(demoMessages);
    };
    //GET MESSAGES
    KinveyRemoteServiceService.prototype.GetAllMessagesById = function (id) {
        return of(demoMessages.filter(function (message) { return message.receiver === id || message.sender === id; }));
    };
    //GET MESSAGE BY ID
    KinveyRemoteServiceService.prototype.GetMessageById = function (id) {
        return of(demoMessages.find(function (message) { return message._id === id; }) || demoMessages[0]);
    };
    //GET USER BY ID
    KinveyRemoteServiceService.prototype.GetUserById = function (id) {
        return of(demoUsers.find(function (user) { return user._id === id || user.username === id; }) || demoUsers[0]);
    };
    //DELETE MESSAGE BY ID
    KinveyRemoteServiceService.prototype.DeleteMessageById = function (id) {
        demoMessages = demoMessages.filter(function (message) { return message._id !== id; });
        return of({ _id: id });
    };
    KinveyRemoteServiceService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [HttpClient])
    ], KinveyRemoteServiceService);
    return KinveyRemoteServiceService;
}());
export default KinveyRemoteServiceService;
//# sourceMappingURL=kinvey-remote-service.service.js.map